/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Friends_EmptyInputs */

const en_friends_empty = /** @type {(inputs: Friends_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No friends yet`)
};

const de_friends_empty = /** @type {(inputs: Friends_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Freunde`)
};

/**
* | output |
* | --- |
* | "No friends yet" |
*
* @param {Friends_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const friends_empty = /** @type {((inputs?: Friends_EmptyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Friends_EmptyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_friends_empty(inputs)
	return en_friends_empty(inputs)
});